// 文章id
export const articleId = {
  commentId: 1165,
  newsId: 1164,
  introduceId: 1163
}

// 网站编码
export const siteCode = 'waxmcyzs'

// 指数时间格式
export const indexTime = {
  540: 'month',
  541: 'year',
  542: 'quarter',
  543: 'year'
}
